// extracted by mini-css-extract-plugin
module.exports = {"root":"k_pw","wrapper":"k_px","image":"k_py h_dm h_dp h_dM","crop":"k_pz","round":"k_pB","fixedHeight":"k_pC"};